import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchFixtureSocialPosts } from "../api";
import SocialPostCard from "./SocialPostCard";

const toRows = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.posts)) return payload.posts;
  if (Array.isArray(payload?.items)) return payload.items;
  return [];
};

export default function FixtureSocialPosts({ fixtureId, title = "Community Posts", limit = 3, dark = false }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!fixtureId) return undefined;
    let cancelled = false;
    (async () => {
      setLoading(true);
      setErr("");
      try {
        const data = await fetchFixtureSocialPosts(fixtureId, { limit });
        if (!cancelled) setPosts(toRows(data).slice(0, limit));
      } catch {
        if (!cancelled) {
          setErr("Posts unavailable.");
          setPosts([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [fixtureId, limit]);

  const text = dark ? "#f8fafc" : "#111827";
  const muted = dark ? "rgba(255,255,255,0.66)" : "rgba(0,0,0,0.58)";

  if (!loading && !err && !posts.length) return null;

  return (
    <section style={{ margin: "18px 0" }}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "baseline", marginBottom: 10 }}>
        <h2 style={{ margin: 0, fontSize: 20, color: text }}>{title}</h2>
        {loading ? <span style={{ fontSize: 12, color: muted }}>Loading...</span> : null}
      </div>
      {err ? <div style={{ color: "#f87171", fontSize: 13 }}>{err}</div> : null}
      <div style={{ display: "grid", gap: 10 }}>
        {posts.map((post, idx) => (
          <SocialPostCard key={post.id || post.post_id || idx} post={post} dark={dark} />
        ))}
      </div>
    </section>
  );
}

export function FixtureSocialPreview({ fixtureId, preview, dark = true, to }) {
  const count = Number(preview?.post_count ?? preview?.count ?? preview?.posts_count ?? 0);
  const sample =
    preview?.latest_body ||
    preview?.body ||
    preview?.latest_post?.body ||
    preview?.posts?.[0]?.body ||
    "";

  if (!count && !sample) return null;

  return (
    <Link
      to={to || `/fixture/${fixtureId}`}
      style={{
        display: "block",
        marginTop: 8,
        padding: "7px 9px",
        borderRadius: 8,
        border: dark ? "1px solid rgba(52,211,153,0.26)" : "1px solid rgba(22,163,74,0.24)",
        background: dark ? "rgba(52,211,153,0.1)" : "rgba(22,163,74,0.08)",
        color: dark ? "#d8f6e6" : "#166534",
        textDecoration: "none",
        fontSize: 12,
        lineHeight: 1.35,
      }}
    >
      <strong>{count ? `${count} community post${count === 1 ? "" : "s"}` : "Community post"}</strong>
      {sample ? `: ${String(sample).slice(0, 92)}${String(sample).length > 92 ? "..." : ""}` : ""}
    </Link>
  );
}
